export type VideoPreviewRequestDto = {
  url: string
}

export type VideoPreviewResponseDto = {
  provider: string
  title: string
  channel: string
  duration?: string | null
  thumbnailUrl: string
}

export type VideoPreview = {
  provider: string
  title: string
  channel: string
  duration?: string | null
  thumbnailUrl: string
}

export type VideoPreviewStatus = 'idle' | 'loading' | 'loaded' | 'error'

export function toVideoPreview(dto: VideoPreviewResponseDto): VideoPreview {
  return {
    provider: dto.provider,
    title: dto.title,
    channel: dto.channel,
    duration: dto.duration,
    thumbnailUrl: dto.thumbnailUrl,
  }
}
